module.exports = __webpack_public_path__ + "img/ttd-dir.084153f7.png";